import type { ApiResponse } from './generic';

export enum WalletDisplayUnit {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
}

export interface LeaveSetting {
  id: string;
  companyId: string;
  startDate: number;
  startMonth: number;
  endDate: number;
  endMonth: number;
  description: string;
  calendarName: string;
  createdAt: string;
  updatedAt: string;
  weeklyHolidays: number[];
}

export interface LeaveSettingsData {
  leaveSetting: LeaveSetting;
}

export type LeaveSettingsResponse = ApiResponse<LeaveSettingsData>;
